import classnames from 'classnames'
import { useTranslation } from 'next-i18next'
import React from 'react'

import styles from './product-tags.module.scss'

const ReadyToShip = ({ shouldShowReadyToShipTag }: { shouldShowReadyToShipTag: boolean }) => {
  const { t } = useTranslation('common')
  return shouldShowReadyToShipTag ? (
    <li className={classnames(styles.tag)} key="readyToShip">
      {t('ready_to_ship')}
    </li>
  ) : null
}

export { ReadyToShip }
